import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Section.module.css';
import { AddButton, DBIntField, DBTimetField } from '_components';

class AlSection extends React.Component {

    handleTimeChange(val) {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }

        //remove this line of code to always track assistant time
        if (!this.props.skipTherapistAssistantTimeCalulation) {
            if (!val) { // if they cleared the total time field, clear our assistant time as well
                this.props.clearField(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, this.props.timeField + 'Assist');
            } else {
                if (this.props.therapistTime) { //if therapist time exists already
                    // compute what the assistant time should be
                    let tmpAssistTime = parseInt(val) - this.props.therapistTime;
                    // if the computed value does not equal what we have in state
                    if (tmpAssistTime !== this.props.assistTime) {
                        // update state (i.e the DB)
                        this.props.updateAlTime(tmpAssistTime, this.props.therapistTime, val, this.props.xlno, this.props.timeField, this.props.noteId);
                    }
                } else { // else therapist time IS null, so we set assistant time based on total time alone
                    // if the therapist is not licensed
                    if (this.props.isAssistant) {
                        // if the assistant time does not already equal the value we're about to set it to
                        if (parseInt(val) !== this.props.assistTime) {
                            // update state (i.e the DB)
                            this.props.updateAlTime(val, undefined, val, this.props.xlno, this.props.timeField, this.props.noteId);
                        }
                    } else { // the therapist is fully licensed, so set the assistant time to zero
                        this.props.updateAlTime(0, undefined, val, this.props.xlno, this.props.timeField, this.props.noteId);
                    }
                }
            }
        }
    }


    handleTherapistTimeChange(val) {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }

        if (this.props.trackAssist) {
            if (this.props.totalTime) { // if there is a total time, then compute assistant time based on the change to therapist time
                if (!val) { // they cleared the therapist time
                    if (this.props.isAssistant) { // if the therapist is not licensed
                        // if the assistant time does not already equal the value we're about to set it to
                        if (this.props.totalTime !== this.props.assistTime) {
                            // update state (i.e the DB)
                            this.props.updateAlTime(this.props.totalTime, undefined, this.props.totalTime, this.props.xlno, this.props.timeField, this.props.noteId);
                        }
                    } else { // the therapist is fully licensed, so set the assistant time to zero
                        this.props.updateAlTime(0, undefined, this.props.totalTime, this.props.xlno, this.props.timeField, this.props.noteId);
                    }
                } else {
                    // compute what the assistant time should be
                    let tmpAssistTime = this.props.totalTime - parseInt(val);
                    // if the computed value does not equal what we have in state
                    if (tmpAssistTime !== this.props.assistTime) {
                        // update state (i.e the DB
                        this.props.updateAlTime(tmpAssistTime, val, this.props.totalTime, this.props.xlno, this.props.timeField, this.props.noteId);
                    }
                }
            }
        }
    }

    render() {
        let cls = styles.wrapper1;

        if (this.props.className) {
            cls += ' ' + styles[this.props.className];
        }

        let childCls = styles.child_wrapper;

        let labelCls;
        if (this.props.subLabel) {
            labelCls = styles.label;
        } else {
            labelCls = this.props.startEndTimeNoteVisibility && this.props.showStartEndTime ? styles.label_wide_wp :styles.label_wide;
        }

        return (
            <div id={this.props.id}>
                <div className={cls}>
                    {this.props.addButtonVisible &&
                        <div className={styles.button} >
                            <AddButton title={'Add ' + this.props.name + '...'} size='extra-small' onClick={() => this.props.onAdd()} className={this.props.chargesExist ? styles.button_dis : null} />
                        </div>
                    }
                    {!this.props.addButtonVisible &&
                        <span className={styles.button_spacer} />
                    }
                    <span className={labelCls}>
                        {this.props.name}
                    </span>
                    {this.props.subLabel &&
                        <span className={styles.sublabel}>
                            {this.props.subLabel}
                        </span>
                    }
                    {this.props.startEndTimeNoteVisibility && this.props.showStartEndTime &&
                        <>
                            <span className={this.props.startTimeRequired ? styles.time_label_req_wp : styles.time_label_wp}>Start Time:</span>
                            <DBTimetField
                                noteId={this.props.noteId}
                                entity='MLEXLOG'
                                entityKeyColumn='XLNO'
                                entityKeyValue={this.props.xlno}
                                handleValueChange={(val) => this.props.onStartTime(val)}
                                field={this.props.startTimeField}
                                className={this.props.startTimeRequired ? styles.time_field_req_wp : styles.time_field_wp}
                                disabled={this.props.chargesExist}
                            />
                            <span className={styles.space} />
                            <span className={this.props.endTimeRequired ? styles.time_label_req_wp : styles.time_label_wp}>End Time:</span>
                            <DBTimetField
                                noteId={this.props.noteId}
                                entity='MLEXLOG'
                                entityKeyColumn='XLNO'
                                entityKeyValue={this.props.xlno}
                                handleValueChange={(val) => this.props.onEndTime(val)}
                                field={this.props.endTimeField}
                                className={this.props.endTimeRequired ? styles.time_field_req_wp : styles.time_field_wp}
                                disabled={this.props.chargesExist}
                            />
                        <span className={styles.space} />
                             <span className={styles.time_label_wp}>Breaks:</span>
                            <DBIntField
                                noteId={this.props.noteId}
                                entity='MLEXLOG'
                                entityKeyColumn='XLNO'
                                entityKeyValue={this.props.xlno}
                                field={this.props.breakField}
                                className={styles.break}
                                handleValueChange={(val) => this.props.onBreakTime(val)}
                                disabled={this.props.chargesExist}
                            />
                            <span className={styles.space} />
                        </>

                    }
                    {(this.props.totalTimeVisible || this.props.timeVisible) &&
                        <span>
                            <span className={this.props.timeRequired ? styles.time_label_req : styles.time_label}>Total Time:</span>
                            <DBIntField
                                noteId={this.props.noteId}
                                entity='MLEXLOG'
                                entityKeyColumn='XLNO'
                                entityKeyValue={this.props.xlno}
                                field={this.props.timeField}
                                className={this.props.timeRequired ? styles.time_field_req_wp : styles.time_field_wp}
                                min={0}
                                onChange={e => this.handleTimeChange(e)}
                                disabled={this.props.chargesExist || this.props.disableTime}
                            />
                        </span>
                    }

                    {this.props.timeVisible && this.props.trackAssist &&
                        <span>
                            <span className={styles.therapist_time_label}>Therapist Time:</span>

                            <DBIntField
                                noteId={this.props.noteId}
                                entity='MLEXLOG'
                                entityKeyColumn='XLNO'
                                entityKeyValue={this.props.xlno}
                                field={this.props.timeField + "THERAPIST"}
                                className={this.props.chargesExist ? styles.time_field_dis : styles.time_field}
                                min={0}
                                onChange={e => this.handleTherapistTimeChange(e)}
                                disabled={this.props.chargesExist}
                            />
                        </span>
                    }
                </div>
                <div className={this.props.chargesExist ? styles.disabled : childCls}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateAlTime: bindActionCreators(noteActions.updateALTime, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let timeVisible =
        (ownprops.timeVisible !== undefined && ownprops.timeVisible === false)
            || (noteType === 3 || noteType === 4) ? false : true;
    let startEndTimeNoteVisibility =
        (ownprops.startEndTimeNoteVisibility !== undefined && ownprops.startEndTimeNoteVisibility === false)
            || (noteType === 3 || noteType === 4) ? false : true;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;
    let totalTime = state.entities.notes.MLEXLOG[xlno][ownprops.timeField];
    let therapistTime = state.entities.notes.MLEXLOG[xlno][ownprops.timeField + 'THERAPIST'];
    let assistTime = state.entities.notes.MLEXLOG[xlno][ownprops.timeField + 'ASSIST'];
    let isAssistant = state.entities.authentication.user.isAssistant;
    let addButtonVisible = (ownprops.addVisible !== undefined && ownprops.addVisible === false) ? false : true;
    let chargesExist = false;
    if (noteType === 1) {
        //do charges exist for eval?
        chargesExist = state.entities.notes.PTEVAL[pk].hasCharges ? true : false;
    }
    else {
        //do charges exist for something else
        chargesExist = state.entities.notes.PTNOTE[pk].hasCharges ? true : false;
    }

    let addUser = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVADDUSER : state.entities.notes.PTNOTE[pk].NTADDUSER;
    let scribing = addUser === state.entities.authentication.user.urno ? false : true;

    if (scribing) {
        isAssistant = noteType === 1 ? state.entities.notes.PTEVAL[pk].AddUserIsAssistant : state.entities.notes.PTNOTE[pk].AddUserIsAssistant;
    }

    return {
        noteId,
        xlno,
        timeVisible,
        computedChargesVisible,
        totalTime,
        therapistTime,
        assistTime,
        isAssistant,
        addButtonVisible,
        chargesExist,
        startEndTimeNoteVisibility
    };
}

const connectedAlSection = connect(mapStateToProps, mapDispatchToProps)(AlSection);
export { connectedAlSection as AlSection };

